import { UPDATE_HOB_DESTINATION_LOCATION, UPDATE_HOB_LANDING_PARAMS, UPDATE_HOB_LANDING_RESPONSE, UPDATE_HOB_LISTING_PARAMS, UPDATE_HOB_LISTING_RESPONSE, UPDATE_HOB_PICKUP_TIME, UPDATE_HOB_SOURCE_LOCATION, UPDATE_HOB_THANKYOU_PARAMS, UPDATE_HOB_THANKYOU_RESPONSE, UPDATE_HOB_USER_DATA, UPDATE_USE_SOURCE_LOCATION } from "./action-types";

const initialState = {
  flightBookingId: '',
  source: '',
  isDeparture: true,
  orgId: '',
  refId: '',
  bookingId: '',
  pickupTime: '',
  source_message: '',
  airport_city_code: '',
  terminal: '',
  useSourceLocation: false,
  destinationLocation: null,
  sourceLocation: null,
  hobLandingResponse: null,
  hobListingResponse: null,
  hobThankYouResponse: null,
  hobUserData: null
}

export default function HOBReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_HOB_LANDING_PARAMS: 
      return {
        ...state,
        flightBookingId: action?.data?.flightBookingId,
        source: action?.data?.source,
        isDeparture: typeof action?.data?.isDeparture === "string" ? JSON.parse(action?.data?.isDeparture) : action?.data?.isDeparture,
        orgId: action?.data?.orgId?.toUpperCase()
      };

    case UPDATE_HOB_LANDING_RESPONSE: 
      return {
        ...state,
        hobLandingResponse: action?.data?.provisionalResponse,
        airport_city_code: action?.data?.airport_city_code,
        source_message: action?.data?.source_message,
        terminal: action?.data?.terminal,
        pickupTime: action?.data?.pickupTime
      };

    case UPDATE_HOB_DESTINATION_LOCATION:
      return {
        ...state,
        destinationLocation: action?.destinationLocation
      };

    case UPDATE_HOB_SOURCE_LOCATION:
      return {
        ...state,
        sourceLocation: action?.sourceLocation
      };

    case UPDATE_HOB_PICKUP_TIME: 
      return {
        ...state,
        pickupTime: action?.pickupTime
      };

    case UPDATE_USE_SOURCE_LOCATION: {
      return {
        ...state,
        useSourceLocation: action?.useSourceLocation,
        sourceLocation: action?.sourceLocation
      };
    }

    case UPDATE_HOB_LISTING_PARAMS:       
      return {
        ...state,
        orgId: action?.data?.orgId?.toUpperCase(),
        flightBookingId: action?.data?.flightBookingId,
        source: action?.data?.source,
        source_message: action?.data?.source_message,
        airport_city_code: action?.data?.airport_city_code,
        terminal: action?.data?.terminal,
        isDeparture: typeof action?.data?.isDeparture === "string" ? JSON.parse(action?.data?.isDeparture) : action?.data?.isDeparture,
        destinationLocation: action?.data?.destinationLocation && typeof action?.data?.destinationLocation === "string" ? JSON.parse(action?.data?.destinationLocation) : {},
        sourceLocation: action?.data?.sourceLocation && typeof action?.data?.sourceLocation === "string" ? JSON.parse(action?.data?.sourceLocation) : null,
        pickupTime: action?.data?.pickupTime
      };

    case UPDATE_HOB_LISTING_RESPONSE:       
      return {
        ...state,
        hobListingResponse: action?.data
      };

    case UPDATE_HOB_THANKYOU_PARAMS:       
      return {
        ...state,
        orgId: action?.data?.orgId?.toUpperCase(),
        refId: action?.data?.refId,
        bookingId: action?.data?.bookingId
      };

    case UPDATE_HOB_THANKYOU_RESPONSE:       
      return {
        ...state,
        hobThankYouResponse: action?.data
      };

    case UPDATE_HOB_USER_DATA:
      return {
        ...state,
        hobUserData : action?.data
      };
 
    default:
      return state;
  }
}